import { DayTableModel, identity } from "@fullcalendar/react";
import queryString from "query-string";

import medusaRequest, { multipartRequest, medusaDownload } from "./request";

const removeNullish = (obj) =>
  Object.entries(obj).reduce((a, [k, v]) => (v ? ((a[k] = v), a) : a), {});

const buildQueryFromObject = (search, prefix = "") =>
  Object.entries(search)
    .map(([key, value]) =>
      typeof value === "object"
        ? buildQueryFromObject(value, key)
        : `${prefix ? `${prefix}[${key}]` : `${key}`}=${value}`
    )
    .join("&");

export default {
  stores: {
    listTypes() {
      const path = `/store/product-type`;
      return medusaRequest("GET", path);
    },
  },
  returnReasons: {
    retrieve(id) {
      const path = `/admin/return-reasons/${id}`;
      return medusaRequest("GET", path);
    },
    list() {
      const path = `/admin/return-reasons`;
      return medusaRequest("GET", path);
    },
    create(payload) {
      const path = `/admin/return-reasons`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/return-reasons/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/return-reasons/${id}`;
      return medusaRequest("DELETE", path);
    },
  },
  apps: {
    authorize(data) {
      const path = `/admin/apps/authorizations`;
      return medusaRequest("POST", path, data);
    },

    list() {
      const path = `/admin/apps`;
      return medusaRequest("GET", path);
    },
  },
  auth: {
    session() {
      const path = `/admin/auth`;
      return medusaRequest("GET", path);
    },
    authenticate(details) {
      const path = `/admin/auth`;
      return medusaRequest("POST", path, details);
    },
    deauthenticate(details) {
      const path = `/admin/auth`;
      return medusaRequest("DELETE", path);
    },
    renew() {
      const path = `/admin/auth/renew`;
      return medusaRequest("GET", path);
    },
    google(payload) {
      const path = `/admin/auth/google`;
      return medusaRequest("POST", path, payload);
    },
    googleRefresh(payload) {
      const path = `/admin/auth/google/refresh-token`;
      return medusaRequest("POST", path, payload);
    },
    googleAuth(payload) {
      const path = `/admin/auth/google/user`;
      return medusaRequest("POST", path, payload);
    },
  },
  account: {
    get(id) {
      const path = `/admin/users/${id}`;
      return medusaRequest("GET", path);
    },
    register(details) {
      const path = `/admin/users`;
      return medusaRequest("POST", path, details);
    },
    update(id, details) {
      const path = `/admin/users/${id}`;
      return medusaRequest("POST", path, details);
    },
    resetPassword(password) {
      const path = `/admin/users/reset-password`;
      return medusaRequest("POST", path, password);
    },
  },
  notifications: {
    /*list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/notifications${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    resend(id, config) {
      const path = `/admin/notifications/${id}/resend`;
      return medusaRequest("POST", path, config);
    },*/
    list() {
      const path = `/admin/notifications/list`;
      return medusaRequest("GET", path);
    },
    create(payload) {
      const path = `/admin/notifications/create`;
      return medusaRequest("Post", path, payload);
    },
    update(payload) {
      const path = `/admin/notifications/update`;
      return medusaRequest("Post", path, payload);
    },
  },
  notes: {
    listByResource(resourceId) {
      const path = `/admin/notes?resource_id=${resourceId}`;
      return medusaRequest("GET", path);
    },
    async create(resourceId, resourceType, value, rating, project_id) {
      const path = `/admin/notes/`;
      return medusaRequest("POST", path, {
        resource_id: resourceId,
        resource_type: resourceType,
        rating,
        value,
        project_id,
      });
    },
    async get(query) {
      const path = `/admin/notes/get`;
      return medusaRequest("POST", path, query);
    },
    update(id, data) {
      const path = `admin/notes/update/${id}`;
      return medusaRequest("POST", path, data);
    },
    delete(id) {
      const path = `admin/notes/${id}`;
      return medusaRequest("DELETE", path);
    },
  },

  customers: {
    retrieve(customerId) {
      const path = `/admin/customers/${customerId}`;
      return medusaRequest("GET", path);
    },
    list(search = "") {
      const path = `/admin/customers${search}`;
      return medusaRequest("GET", path);
    },
    update(customerId, update) {
      const path = `admin/customers/${customerId}`;
      return medusaRequest("POST", path, update);
    },
  },
  store: {
    retrieve() {
      const path = `/admin/store`;
      return medusaRequest("GET", path);
    },

    update(update) {
      const path = `/admin/store`;
      return medusaRequest("POST", path, update);
    },

    addCurrency(code) {
      const path = `/admin/store/currencies/${code}`;
      return medusaRequest("POST", path);
    },

    removeCurrency(code) {
      const path = `/admin/store/currencies/${code}`;
      return medusaRequest("DELETE", path);
    },

    listPaymentProviders() {
      const path = `/admin/store/payment-providers`;
      return medusaRequest("GET", path);
    },
  },
  shippingProfiles: {
    list() {
      const path = `/admin/shipping-profiles`;
      return medusaRequest("GET", path);
    },

    create(data) {
      const path = `/admin/shipping-profiles`;
      return medusaRequest("POST", path, data);
    },

    retrieve(profileId) {
      const path = `/admin/shipping-profiles/${profileId}`;
      return medusaRequest("GET", path);
    },

    update(profileId, update) {
      const path = `/admin/shipping-profiles/${profileId}`;
      return medusaRequest("POST", path, update);
    },
  },

  giftCards: {
    create(giftCard) {
      const path = `/admin/gift-cards`;
      return medusaRequest("POST", path, giftCard);
    },

    retrieve(giftCardId) {
      const path = `/admin/gift-cards/${giftCardId}`;
      return medusaRequest("GET", path);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/gift-cards${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    update(giftCardId, update) {
      const path = `/admin/gift-cards/${giftCardId}`;
      return medusaRequest("POST", path, update);
    },

    delete(giftCardId) {
      const path = `/admin/gift-cards/${giftCardId}`;
      return medusaRequest("DELETE", path);
    },
  },

  variants: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/variants${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },

  products: {
    create(product) {
      const path = `/admin/products`;
      return medusaRequest("POST", path, product);
    },

    retrieve(productId) {
      const path = `/admin/products/${productId}`;
      return medusaRequest("GET", path);
    },

    update(productId, update, projectId = "") {
      const path = `/admin/products/${productId}` + (projectId !== "" ? "?pid=" + projectId : "");
      return medusaRequest("POST", path, update);
    },

    delete(productId) {
      const path = `/admin/products/${productId}`;
      return medusaRequest("DELETE", path);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/products${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    listStyles(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/products/styles${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    listTypes() {
      const path = `/admin/products/types`;
      return medusaRequest("GET", path);
    },

    listTagsByUsage() {
      const path = `/admin/products/tag-usage`;
      return medusaRequest("GET", path);
    },
    searchStyles(search = {}) {
      const path = `/admin/products/search-style`;
      return medusaRequest("POST", path, search);
    },
    adminSearchStyles(search = {}) {
      const path = `/admin/products/admin-search-style`;
      return medusaRequest("POST", path, search);
    },
    listProjectsByStyle(id) {
      //style_id
      const path = `/admin/products/styles/${id}/project`;
      return medusaRequest("GET", path);
    },
    sharingList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/products/styles/sharing${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/products/styles/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    updateTechpackCollaboration(techpackcollaboration) {
      const path = `/admin/products/techpackcollaboration/update`;
      return medusaRequest("POST", path, techpackcollaboration);
    },
    getTechpackCollaboration(pid) {
      const path = `/admin/products/techpackcollaboration/${pid}`;

      return medusaRequest("GET", path);
    },
    setMode(id, payload) {
      const path = `/admin/products/${id}/mode`;
      return medusaRequest("POST", path, payload);
    },
    duplicate(id) {
      //the item can be duplicated only it is shared to all designers
      const path = `/admin/products/duplicate/${id}`;
      return medusaRequest("POST", path);
    },
    variants: {
      create(productId, variant) {
        const path = `/admin/products/${productId}/variants`;
        return medusaRequest("POST", path, variant);
      },

      retrieve(productId, variantId) {
        const path = `/admin/products/${productId}/variants/${variantId}`;
        return medusaRequest("GET", path);
      },

      update(productId, variantId, update) {
        const path = `/admin/products/${productId}/variants/${variantId}`;
        return medusaRequest("POST", path, update);
      },

      delete(productId, variantId) {
        const path = `/admin/products/${productId}/variants/${variantId}`;
        return medusaRequest("DELETE", path);
      },

      list(productId) {
        const path = `/admin/products/${productId}/variants`;
        return medusaRequest("GET", path);
      },
    },

    options: {
      create(productId, option) {
        const path = `/admin/products/${productId}/options`;
        return medusaRequest("POST", path, option);
      },

      delete(productId, optionId) {
        const path = `/admin/products/${productId}/options/${optionId}`;
        return medusaRequest("DELETE", path);
      },

      update(productId, optionId, update) {
        const path = `/admin/products/${productId}/options/${optionId}`;
        return medusaRequest("POST", path, update);
      },
    },
  },

  secionPhotos: {
    create(section) {
      const path = `/admin/sections`;
      return medusaRequest("POST", path, section);
    },

    load() {
      const path = `/admin/sections/load`;
      return medusaRequest("GET", path);
    },

    update(section) {
      const path = `/admin/sections/update`;
      return medusaRequest("POST", path, section);
    },
  },

  sendConfirmEmail: {
    sendEmail(payload) {
      const path = `/admin/invites/verification/`; //send claim email reminder for manufacturer
      return medusaRequest("POST", path, payload);
    },
    resendVerificationEmail(payload) {
      //resend verification email for users whos registered by invite code
      const path = `/admin/invitecode/resend-verification-email`;
      return medusaRequest("POST", path, payload);
    },
  },

  swaps: {
    retrieve(swapId) {
      const path = `/admin/swaps/${swapId}`;
      return medusaRequest("GET", path);
    },

    update(orderId, update) {
      const path = `/admin/orders/${orderId}`;
      return medusaRequest("POST", path, update);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => {
          if (search[k] === "" || search[k] === null) {
            return null;
          }
          return `${k}=${search[k]}`;
        })
        .filter((s) => !!s)
        .join("&");
      const path = `/admin/swaps${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },

  returns: {
    list(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${search[k]}`)
        .filter((s) => !!s)
        .join("&");
      const path = `/admin/returns${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },

  collections: {
    create(payload) {
      const path = `/admin/collections`;
      return medusaRequest("POST", path, payload);
    },

    retrieve(id) {
      const path = `/admin/collections/${id}`;
      return medusaRequest("GET", path);
    },

    list(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${search[k]}`)
        .filter((s) => !!s)
        .join("&");

      const path = `/admin/collections${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    listAdmin(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${search[k]}`)
        .filter((s) => !!s)
        .join("&");

      const path = `/admin/collections/admin-list-collections${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    add(id, productIds) {
      const path = `/admin/collections/${id}/products`;
      const payload = { product_ids: productIds };
      return medusaRequest("POST", path, payload);
    },
    cloneAdd(id, productIds) {
      const path = `/admin/collections/${id}/cloneproducts`;
      const payload = { product_ids: productIds };
      return medusaRequest("POST", path, payload);
    },

    update(id, payload) {
      const path = `/admin/collections/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/collections/${id}`;
      return medusaRequest("DELETE", path);
    },
    sharingList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/collections/sharing${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/collections/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    setMode(id, payload) {
      const path = `/admin/collections/${id}/mode`;
      return medusaRequest("POST", path, payload);
    },
  },

  orders: {
    create(order) {
      const path = `/admin/orders`;
      return medusaRequest("POST", path, order);
    },

    async receiveReturn(returnId, payload) {
      const path = `/admin/returns/${returnId}/receive`;

      const received = await medusaRequest("POST", path, payload);

      let orderId;
      if (received.data.return?.order_id) {
        orderId = received.data.return.order_id;
      }

      if (received.data.return?.swap?.id) {
        orderId = received.data.return?.swap?.order_id;
      }

      return this.retrieve(orderId);
    },

    cancelReturn(returnId) {
      const path = `/admin/returns/${returnId}/cancel`;
      return medusaRequest("POST", path);
    },

    retrieve(orderId, search = {}) {
      const params = Object.keys(search)
        .map((k) => {
          if (search[k] === "" || search[k] === null) {
            return null;
          }
          return `${k}=${search[k]}`;
        })
        .filter((s) => !!s)
        .join("&");
      const path = `/admin/orders/${orderId}${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    update(orderId, update) {
      const path = `/admin/orders/${orderId}`;
      return medusaRequest("POST", path, update);
    },

    list(search = {}) {
      const clean = removeNullish(search);
      const params = Object.keys(clean)
        .map((k) => `${k}=${search[k]}`)
        .filter((s) => !!s)
        .join("&");

      const path = `/admin/orders${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    complete(orderId) {
      const path = `/admin/orders/${orderId}/complete`;
      return medusaRequest("POST", path, {});
    },

    archive(orderId) {
      const path = `/admin/orders/${orderId}/archive`;
      return medusaRequest("POST", path, {});
    },

    capturePayment(orderId) {
      const path = `/admin/orders/${orderId}/capture`;
      return medusaRequest("POST", path, {});
    },

    createShipment(orderId, payload) {
      const path = `/admin/orders/${orderId}/shipment`;
      return medusaRequest("POST", path, payload);
    },

    updateClaim(orderId, claimId, payload) {
      const path = `/admin/orders/${orderId}/claims/${claimId}`;
      return medusaRequest("POST", path, payload);
    },

    createSwap(orderId, payload) {
      const path = `/admin/orders/${orderId}/swaps`;
      return medusaRequest("POST", path, payload);
    },

    cancelSwap(orderId, swapId) {
      const path = `/admin/orders/${orderId}/swaps/${swapId}/cancel`;
      return medusaRequest("POST", path);
    },

    createClaim(orderId, payload) {
      const path = `/admin/orders/${orderId}/claims`;
      return medusaRequest("POST", path, payload);
    },

    cancelClaim(orderId, claimId) {
      const path = `/admin/orders/${orderId}/claims/${claimId}/cancel`;
      return medusaRequest("POST", path);
    },

    fulfillClaim(orderId, claimId, payload) {
      const path = `/admin/orders/${orderId}/claims/${claimId}/fulfillments`;
      return medusaRequest("POST", path, payload);
    },

    cancelClaimFulfillment(orderId, claimId, fulfillmentId) {
      const path = `/admin/orders/${orderId}/claims/${claimId}/fulfillments/${fulfillmentId}/cancel`;
      return medusaRequest("POST", path);
    },

    createClaimShipment(orderId, cId, payload) {
      const path = `/admin/orders/${orderId}/claims/${cId}/shipments`;
      return medusaRequest("POST", path, payload);
    },

    createSwapShipment(orderId, swapId, payload) {
      const path = `/admin/orders/${orderId}/swaps/${swapId}/shipments`;
      return medusaRequest("POST", path, payload);
    },

    fulfillSwap(orderId, swapId, payload) {
      const path = `/admin/orders/${orderId}/swaps/${swapId}/fulfillments`;
      return medusaRequest("POST", path, payload);
    },

    cancelSwapFulfillment(orderId, swapId, fulfillmentId) {
      const path = `/admin/orders/${orderId}/swaps/${swapId}/fulfillments/${fulfillmentId}/cancel`;
      return medusaRequest("POST", path);
    },

    processSwapPayment(orderId, swapId) {
      const path = `/admin/orders/${orderId}/swaps/${swapId}/process-payment`;
      return medusaRequest("POST", path);
    },

    createFulfillment(orderId, payload) {
      const path = `/admin/orders/${orderId}/fulfillment`;
      return medusaRequest("POST", path, payload);
    },

    cancelFulfillment(orderId, fulfillmentId) {
      const path = `/admin/orders/${orderId}/fulfillments/${fulfillmentId}/cancel`;
      return medusaRequest("POST", path);
    },

    refund(orderId, payload) {
      const path = `/admin/orders/${orderId}/refund`;
      return medusaRequest("POST", path, payload);
    },

    requestReturn(orderId, payload) {
      const path = `/admin/orders/${orderId}/return`;
      return medusaRequest("POST", path, payload);
    },

    cancel(orderId) {
      const path = `/admin/orders/${orderId}/cancel`;
      return medusaRequest("POST", path, {});
    },
  },

  shippingOptions: {
    create(shippingOption) {
      const path = `/admin/shipping-options`;
      return medusaRequest("POST", path, shippingOption);
    },

    retrieve(id) {
      const path = `/admin/shipping-options/${id}`;
      return medusaRequest("POST", path);
    },

    delete(id) {
      const path = `/admin/shipping-options/${id}`;
      return medusaRequest("DELETE", path);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/shipping-options${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    update(id, update) {
      const path = `/admin/shipping-options/${id}`;
      return medusaRequest("POST", path, update);
    },
  },

  discounts: {
    create(discount) {
      const path = `/admin/discounts`;
      return medusaRequest("POST", path, discount);
    },

    retrieve(discountId) {
      const path = `/admin/discounts/${discountId}`;
      return medusaRequest("GET", path);
    },

    update(discountId, update) {
      const path = `/admin/discounts/${discountId}`;
      return medusaRequest("POST", path, update);
    },

    delete(discountId) {
      const path = `/admin/discounts/${discountId}`;
      return medusaRequest("DELETE", path);
    },

    list(search = {}) {
      const params = buildQueryFromObject(search);
      const path = `/admin/discounts${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    retrieveByCode(code) {
      const path = `/admin/discounts/code/${code}`;
      return medusaRequest("GET", path);
    },
  },

  regions: {
    list() {
      const path = `/admin/regions`;
      return medusaRequest("GET", path);
    },

    retrieve(id) {
      const path = `/admin/regions/${id}`;
      return medusaRequest("GET", path);
    },

    create(region) {
      const path = `/admin/regions`;
      return medusaRequest("POST", path, region);
    },

    update(id, region) {
      const path = `/admin/regions/${id}`;
      return medusaRequest("POST", path, region);
    },

    delete(id) {
      const path = `/admin/regions/${id}`;
      return medusaRequest("DELETE", path);
    },
    payment: {
      create(regionId, provider_id) {
        const path = `/admin/regions/${regionId}/payment-providers`;
        return medusaRequest("POST", path, provider_id);
      },
    },
    fulfillmentOptions: {
      list(regionId) {
        const path = `/admin/regions/${regionId}/fulfillment-options`;
        return medusaRequest("GET", path);
      },
    },
  },

  uploads: {
    create(files, config = {}, directory = "") {
      const formData = new FormData();
      for (const f of files) {
        formData.append("files", f);
      }
      var url = "/admin/uploads";
      if (directory) url += "?directory=" + directory;
      return multipartRequest(url, formData, config);
    },

    downloadurl(url) {
      const path = `/admin/uploads/downloadurl`;
      return medusaRequest("POST", path, url);
    },
  },

  draftOrders: {
    create(draftOrder) {
      const path = `/admin/draft-orders`;
      return medusaRequest("POST", path, draftOrder);
    },

    addLineItem(draftOrderId, line) {
      const path = `/admin/draft-orders/${draftOrderId}/line-items`;
      return medusaRequest("POST", path, line);
    },

    updateLineItem(draftOrderId, lineId, line) {
      const path = `/admin/draft-orders/${draftOrderId}/line-items/${lineId}`;
      return medusaRequest("POST", path, line);
    },

    deleteLineItem(draftOrderId, lineId) {
      const path = `/admin/draft-orders/${draftOrderId}/line-items/${lineId}`;
      return medusaRequest("DELETE", path);
    },

    retrieve(id) {
      const path = `/admin/draft-orders/${id}`;
      return medusaRequest("GET", path);
    },

    delete(id) {
      const path = `/admin/draft-orders/${id}`;
      return medusaRequest("DELETE", path);
    },

    update(id, payload) {
      const path = `/admin/draft-orders/${id}`;
      return medusaRequest("POST", path, payload);
    },

    registerSystemPayment(id) {
      const path = `/admin/draft-orders/${id}/pay`;
      return medusaRequest("POST", path);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => {
          if (search[k] === "" || search[k] === null) {
            return null;
          }
          return `${k}=${search[k]}`;
        })
        .filter((s) => !!s)
        .join("&");
      const path = `/admin/draft-orders${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  invites: {
    create(data) {
      const path = `/admin/invites`;
      return medusaRequest("POST", path, data);
    },
    resend(inviteId) {
      const path = `/admin/invites/${inviteId}/resend`;
      return medusaRequest("POST", path);
    },
    delete(inviteId) {
      const path = `/admin/invites/${inviteId}`;
      return medusaRequest("DELETE", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => {
          if (search[k] === "" || search[k] === null) {
            return null;
          }
          return `${k}=${search[k]}`;
        })
        .filter((s) => !!s)
        .join("&");

      const path = `/admin/invites${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    accept(data) {
      const path = `/admin/invites/accept`;
      return medusaRequest("POST", path, data);
    },
    getUser(token) {
      const path = `/admin/invites/claim/user?token=${token}`;
      return medusaRequest("GET", path);
    },
  },
  users: {
    resetPasswordToken(data) {
      const path = `/admin/users/password-token`;
      return medusaRequest("POST", path, data);
    },
    resetPassword(data) {
      const path = `/admin/users/reset-password`;
      return medusaRequest("POST", path, data);
    },

    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/users${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },

    retrieve(userId) {
      const path = `/admin/users/${userId}`;
      return medusaRequest("GET", path);
    },

    update(userId, data) {
      const path = `/admin/users/${userId}`;
      return medusaRequest("POST", path, data);
    },

    delete(userId) {
      const path = `/admin/users/${userId}`;
      return medusaRequest("DELETE", path);
    },
    search(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/users/search`;
      return medusaRequest("POST", path, search);
    },
    deleteMyAccount() {
      const path = `/admin/users/myaccount`;
      return medusaRequest("DELETE", path);
    },
  },
  locale: {
    translate(data) {
      const path = `/admin/translation`;
      if (!data.to_lang) {
        data.to_lang = "en";
      }
      return medusaRequest("POST", path, data);
    },
  },
  storeTag: {
    addStoreTag(tag) {
      const path = `/admin/store-tag`;
      return medusaRequest("POST", path, tag);
    },
    listStoreTags() {
      const path = `/admin/store-tag`;
      return medusaRequest("GET", path);
    },
    getStoreTag(id) {
      const path = `/admin/store-tag/${id}`;
      return medusaRequest("GET", path);
    },
    deleteStoreTag(id) {
      const path = `/admin/store-tag/${id}`;
      return medusaRequest("DELETE", path);
    },
  },
  userCapability: {
    addUserCapability(userCapability) {
      const path = `/admin/user-capability`;
      return medusaRequest("POST", path, userCapability);
    },
    listUserCapability() {
      const path = `/admin/user-capability`;
      return medusaRequest("GET", path);
    },
    getUserCapability(id) {
      const path = `/admin/user-capability/${id}`;
      return medusaRequest("GET", path);
    },
    deleteUserCapability(id) {
      const path = `/admin/user-capability/${id}`;
      return medusaRequest("DELETE", path);
    },
  },
  chatroom: {
    findChatRoom(chatroom) {
      const path = `/admin/chatroom/?findonly=1`;
      return medusaRequest("POST", path, chatroom);
    },
    addChatRoom(chatroom) {
      const path = `/admin/chatroom/`;
      return medusaRequest("POST", path, chatroom);
    },
    newMessageCounts() {
      const path = `/admin/chatroom/newmessagecounts`;
      return medusaRequest("GET", path);
    },
    listChatRoom(tab, typeid, projectid) {
      const path = `/admin/chatroom/?tab=${tab}&typeid=${typeid}&projectid=${projectid}`;
      return medusaRequest("GET", path);
    },
    relSetStatus(id, status) {
      const path = `/admin/chatroom/${id}/relsetstatus/${status}`;
      return medusaRequest("GET", path);
    },
    markAsUnread(id) {
      const path = `/admin/chatroom/${id}/markasunread`;
      return medusaRequest("GET", path);
    },
    hideChat(id) {
      const path = `/admin/chatroom/${id}/hide`;
      return medusaRequest("GET", path);
    },
    getChatRoom(id, filter) {
      const path = `/admin/chatroom/${id}`;
      return medusaRequest("POST", path, filter);
    },
    sendmessage(id, message) {
      const path = `/admin/chatroom/${id}/sendmessage`;
      return medusaRequest("POST", path, message);
    },
    setmsgstar(id, message) {
      const path = `/admin/chatroom/${id}/setmsgstar`;
      return medusaRequest("POST", path, message);
    },
    listContacts(accounttype) {
      const path = `/admin/chatroom/contacts?accounttype=${accounttype}`;
      return medusaRequest("GET", path);
    },
  },
  social: {
    follow(related_user_id, type) {
      const path = `/admin/userrelation/follow/${related_user_id}?type=${type}`;
      return medusaRequest("GET", path);
    },
    friend(related_user_id, type) {
      const path = `/admin/userrelation/friend/${related_user_id}?type=${type}`;
      return medusaRequest("GET", path);
    },
    list(account_type, mode, searchstr) {
      const qstr = queryString.stringify({
        account_type: account_type,
        mode: mode,
        searchstr: searchstr,
      });
      const path = `/admin/userrelation/list?${qstr}`;
      return medusaRequest("GET", path);
    },
    followlist(type) {
      const path = `/admin/userrelation/followlist?type=${type}`;
      return medusaRequest("GET", path);
    },
    friendlist(account_type) {
      const path = `/admin/userrelation/friendlist?account_type=${account_type}`;
      return medusaRequest("GET", path);
    },
    getcount(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/userrelation/counts${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    recommendedlist(payload) {
      const path = `/admin/userrelation/recommendedlist`;
      return medusaRequest("POST", path, payload);
    },
  },
  project: {
    create(payload) {
      const path = `/admin/project`;
      return medusaRequest("POST", path, payload);
    },
    delete(projectid) {
      const path = `/admin/project/${projectid}`;
      return medusaRequest("DELETE", path);
    },
    update(projectid, payload) {
      const path = `/admin/project/${projectid}`;
      return medusaRequest("POST", path, payload);
    },
    get(projectid) {
      const path = `/admin/project/${projectid}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const qstr = queryString.stringify(search);
      const path = `/admin/project${qstr && `?${qstr}`}`;
      return medusaRequest("GET", path);
    },
    listAdmin(search = {}) {
      const qstr = queryString.stringify(search);
      const path = `/admin/project/admin${qstr && `?${qstr}`}`;
      return medusaRequest("GET", path);
    },
    updateResponse(payload) {
      //{id:"xx",message:"xxx"}
      const path = `/admin/project/response/audiences`;
      return medusaRequest("POST", path, payload);
    },
    updateStatus(payload = {}) {
      const path = `/admin/project/${payload.id}/status/${payload.status}`;
      return medusaRequest("POST", path, payload);
    },
    search(search = {}) {
      const path = `/admin/project/search`;
      return medusaRequest("POST", path, search);
    },
    // assume admin, will search all projects
    search_admin(search = {}) {
      const path = `/admin/project/search?admin=1`;
      return medusaRequest("POST", path, search);
    },
    listByResponse() {
      const path = `/admin/project/responsed`;
      return medusaRequest("GET", path);
    },
    listFavoriteProjects(search = {}) {
      const qstr = queryString.stringify(search);
      const path = `/admin/project/favorite${qstr && `?${qstr}`}`;
      return medusaRequest("GET", path);
    },
  },
  manufacturer: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/users/list/manufacturer${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  designer: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/users/list/designer${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  invitecode: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/invitecode${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    create(payload) {
      const path = `/admin/invitecode`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `admin/invitecode/${id}`;
      return medusaRequest("DELETE", path);
    },
    accept(payload) {
      const path = `/admin/invitecode/accept`;
      return medusaRequest("POST", path, payload);
    },
    get(code) {
      const path = `/admin/invitecode/meta/${code}`;
      return medusaRequest("GET", path);
    },
    verifyEmail({ token, email }) {
      // verify email address after using invite code to register
      const path = `/admin/invitecode/verify?token=${token}&email=${email}`;
      return medusaRequest("GET", path);
    },
  },
  event: {
    list({ resource_type, user_id }) {
      const path = `/admin/user-view?resource_type=${resource_type}&user_id=${user_id}}`;
      return medusaRequest("GET", path);
    },
    update(payload) {
      //{user_id:xx,resource_type:xx,resource_id:xx,action:xx}
      const path = `/admin/user-view`;
      return medusaRequest("POST", path, payload);
    },
  },
  favorites: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");

      const path = `/admin/user-favorites${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    create(payload) {
      const path = `/admin/user-favorites`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/user-favorites/${id}`;
      return medusaRequest("PUT", path, payload);
    },
    delete(id) {
      const path = `/admin/user-favorites/${id}`;
      return medusaRequest("DELETE", path);
    },

    get(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/user-favorites/get${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  blog: {
    homepage() {
      const path = `/admin/blog/homepage`;
      return medusaRequest("GET", path);
    },
    create(payload) {
      const path = `/admin/blog/create`;
      return medusaRequest("POST", path, payload);
    },
    update(payload) {
      const path = `/admin/blog/update`;
      return medusaRequest("POST", path, payload);
    },
    get(id) {
      const path = `/admin/blog/get/${id}`;
      return medusaRequest("GET", path);
    },
    publish(id) {
      const path = `/admin/blog/publish/${id}`;
      return medusaRequest("GET", path);
    },
    delete(id) {
      const path = `/admin/blog/delete/${id}`;
      return medusaRequest("GET", path);
    },
    getuserblogs(userid) {
      const path = `/admin/blog/userblog/${userid}`;
      return medusaRequest("GET", path);
    },
  },
  comment: {
    create(payload) {
      const path = `/admin/comment/create`;
      return medusaRequest("POST", path, payload);
    },
    update(payload) {
      const path = `/admin/comment/update`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/comment/delete/${id}`;
      return medusaRequest("GET", path);
    },
    get(subjectid) {
      const path = `/admin/comment/get/${subjectid}`;
      return medusaRequest("GET", path);
    },
    updatelikeflag(id, likeflag) {
      const path = `/admin/comment/updatelikeflag/${id}/${likeflag}`;
      return medusaRequest("GET", path);
    },
    sketch_create(payload) {
      const path = `/admin/comment/sketchcommentcreate`;
      return medusaRequest("POST", path, payload);
    },
    sketch_get(payload) {
      const path = `/admin/comment/sketchcommentget`;
      return medusaRequest("POST", path, payload);
    },
    sketch_update(payload) {
      const path = `/admin/comment/sketchcommentupdate`;
      return medusaRequest("POST", path, payload);
    },
    sketch_delete(id) {
      const path = `/admin/comment/sketchcommentdelete/${id}`;
      return medusaRequest("GET", path);
    },
  },
  moodboard: {
    create(payload) {
      const path = `/admin/moodboard/create`;
      return medusaRequest("POST", path, payload);
    },
    update(payload) {
      const path = `/admin/moodboard/update`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/moodboard/delete/${id}`;
      return medusaRequest("GET", path);
    },
    get(id) {
      const path = `/admin/moodboard/get/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/moodboard/list${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    createlink(payload) {
      const path = `/admin/moodboard/createlink`;
      return medusaRequest("POST", path, payload);
    },
    deletelink(id) {
      const path = `/admin/moodboard/deletelink/${id}`;
      return medusaRequest("GET", path);
    },
    listlink(collection_id) {
      const path = `/admin/moodboard/listlink/${collection_id}`;
      return medusaRequest("GET", path);
    },
    sharingList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/moodboard/sharing${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/moodboard/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    updateCollectionRelation(id, payload) {
      const path = `/admin/moodboard/${id}`;
      return medusaRequest("POST", path, payload);
    },
    setMode(id, payload) {
      const path = `/admin/moodboard/${id}/mode`;
      return medusaRequest("POST", path, payload);
    },
    adminList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/moodboard/admin-list${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  resourcePermission: {
    grant(payload) {
      const path = `/admin/resource-permission`;
      return medusaRequest("POST", path, payload);
    },
    revoke(payload) {
      const path = `/admin/resource-permission/revoke`;
      return medusaRequest("POST", path, payload);
    },
    sharingList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/resource-permission${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/resource-permission/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    retrieveCollaborators(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/resource-permission/collaborator${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    grantAll(payload) {
      const path = `/admin/resource-permission/all`;
      return medusaRequest("POST", path, payload);
    },
  },
  palette: {
    create(payload) {
      const path = `/admin/palette`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/palette/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/palette/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/palette/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/palette${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  sizeChart: {
    create(payload) {
      const path = `/admin/size-chart`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/size-chart/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/size-chart/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/size-chart/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/size-chart${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharingList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/size-chart/sharing${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/size-chart/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  calendar: {
    createCalendar(payload) {
      const path = `/admin/calendar`;
      return medusaRequest("POST", path, payload);
    },
    updateCalendar(id, payload) {
      const path = `/admin/calendar/${id}`;
      return medusaRequest("POST", path, payload);
    },
    deleteCalendar(id) {
      const path = `/admin/calendar/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieveCalendar(id) {
      const path = `/admin/calendar/${id}`;
      return medusaRequest("GET", path);
    },
    listCalendars(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/calendar${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    exportCalendar(id) {
      const path = `/admin/calendar/export/${id}`;
      return medusaDownload(path);
    },
    importCalendar(id, file, config = {}) {
      const path = `/admin/calendar/import/${id}`;
      const formData = new FormData();

      formData.append("file", file);

      return multipartRequest(path, formData, config);
    },
    sharingCalendarList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/calendar/sharing${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    sharedCalendarList(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/calendar/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    createEvent(payload) {
      const path = `/admin/calendar-event`;
      return medusaRequest("POST", path, payload);
    },
    updateEvent(id, payload) {
      const path = `/admin/calendar-event/${id}`;
      return medusaRequest("POST", path, payload);
    },
    deleteEvent(id) {
      const path = `/admin/calendar-event/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieveEvent(id) {
      const path = `/admin/calendar-event/${id}`;
      return medusaRequest("GET", path);
    },
    listEvents(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/calendar-event${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    listSharedCalendarEvents(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/calendar-event/shared${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  userVisit: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/users/list/user-visit${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  ailab: {
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/ailab/list${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    delete(id) {
      const path = `/admin/ailab/delete/${id}`;
      return medusaRequest("GET", path);
    },
    get(id) {
      const path = `/admin/ailab/get/${id}`;
      return medusaRequest("GET", path);
    },
    save(payload) {
      const path = `/admin/ailab/save`;
      return medusaRequest("POST", path, payload);
    },
    sendJob(payload) {
      const path = `/admin/ai-job`;
      return medusaRequest("POST", path, payload);
    },
    queryJob(id) {
      const path = `/admin/ai-job?id=${id}`;
      return medusaRequest("GET", path);
    },
    deleteJob(id) {
      const path = `/admin/ai-job/${id}`;
      return medusaRequest("DELETE", path);
    },
    promptRec(payload) {
      const path = `/admin/ai-job/prompt-rec`;
      return medusaRequest("POST", path, payload);
    },
    promptTagRec(payload) {
      const path = `/admin/ai-job/prompt-tag-rec`;
      return medusaRequest("POST", path, payload);
    },
  },
  post: {
    create(payload) {
      const path = `/admin/post`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/post/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/post/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/post/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/post${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    updateAmount(payload) {
      const path = `/admin/post/update-amount`;
      return medusaRequest("PUT", path, payload);
    },
    searchPosts(search = {}) {
      const path = `/admin/post/search-posts`;
      return medusaRequest("POST", path, search);
    },
  },
  score: {
    create(payload) {
      const path = `/admin/score`;
      return medusaRequest("POST", path, payload);
    },
    update(item_id, payload) {
      const path = `/admin/score/${item_id}`;
      return medusaRequest("POST", path, payload);
    },
    retrieve(item_id) {
      const path = `/admin/score/${item_id}`;
      return medusaRequest("GET", path);
    },
    delete(id) {
      const path = `/admin/score/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieveAvgScore(id) {
      const path = `/admin/score/avg/${id}`;
      return medusaRequest("GET", path);
    },
  },
  onlineResource: {
    create(payload) {
      const path = `/admin/online_resource`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/online_resource/${id}`;
      return medusaRequest("POST", path, payload);
    },
    retrieve(id) {
      const path = `/admin/online_resource/${id}`;
      return medusaRequest("GET", path);
    },
    delete(id) {
      const path = `/admin/online_resource/${id}`;
      return medusaRequest("DELETE", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/online_resource${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
  },
  materialLibrary: {
    create(payload) {
      const path = `/admin/material-library`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/material-library/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/material-library/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/material-library/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/material-library${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    bulkCreate(payload) {
      const path = `/admin/material-library/bulk-create`;
      return medusaRequest("POST", path, payload);
    },
  },
  uwProduct: {
    create(payload) {
      const path = `/admin/unionwear-product`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/unionwear-product/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/unionwear-product/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/unionwear-product/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/unionwear-product${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    bulkCreate(payload) {
      const path = `/admin/unionwear-product/bulk-create`;
      return medusaRequest("POST", path, payload);
    },
    aiTask(payload) {
      const path = `/admin/unionwear-product/ai-task`;
      return medusaRequest("POST", path, payload);
    },
  },
  userSetting: {
    update(payload) {
      const path = `/admin/user-setting`;
      return medusaRequest("POST", path, payload);
    },

    retrieve() {
      const path = `/admin/user-setting`;
      return medusaRequest("GET", path);
    },
  },
  uwProject: {
    create(payload) {
      const path = `/admin/unionwear-project`;
      return medusaRequest("POST", path, payload);
    },
    update(id, payload) {
      const path = `/admin/unionwear-project/${id}`;
      return medusaRequest("POST", path, payload);
    },
    delete(id) {
      const path = `/admin/unionwear-project/${id}`;
      return medusaRequest("DELETE", path);
    },
    retrieve(id) {
      const path = `/admin/unionwear-project/${id}`;
      return medusaRequest("GET", path);
    },
    list(search = {}) {
      const params = Object.keys(search)
        .map((k) => `${k}=${search[k]}`)
        .join("&");
      const path = `/admin/unionwear-project${params && `?${params}`}`;
      return medusaRequest("GET", path);
    },
    projectAiTasks(payload) {
      const path = `/admin/unionwear-product/project-ai-task`;
      return medusaRequest("POST", path, payload);
    },
    updateAiResultImage(payload) {
      const path = `/admin/unionwear-product/update-result-image`;
      return medusaRequest("POST", path, payload);
    },
  },
};
